// extracted by mini-css-extract-plugin
export default {"Color":"ColorPicker_Color__VVY1k","SvgIcon":"ColorPicker_SvgIcon__LAc70","ColorSelected":"ColorPicker_ColorSelected__Dp9WT"};